<template>
  <h3 class="mt-5">
    {{ $t('resetpasswordpage.title') }}
  </h3>
  <Message
    v-if="success"
    severity="success"
    :closable="false"
  >
    {{ $t('resetpasswordpage.input.information') }}
  </Message>
  <form @submit.prevent="reset">
    <div class="p-input mb-3">
      <label
        for="email"
        class="required-input"
      >{{ $t('resetpasswordpage.input.email') }}</label>
      <InputText
        id="email"
        v-model.trim="v$.email.$model"
        class="col-12 mt-2"
        :class="{'invalid-input': v$.email.$error }"
        type="text"
        autocomplete="on"
        required
      />
      <div
        v-for="error of v$.email.$errors"
        :key="error.$uid"
        class="input-errors"
      >
        <div class="error-msg">
          {{ error.$message }}
        </div>
      </div>
    </div>

    <div class="text-right mt-3">
      <div
        v-if="isSaving"
        class="inline-block mr-4"
      >
        <div class="loader-dots">
          <div />
          <div />
          <div />
        </div>
      </div>

      <Button
        type="submit"
        label="Primary"
        class="p-button-rounded p-button-outlined"
        :disabled="resetButtonDisabled"
      >
        {{ $t('resetpasswordpage.input.reset') }}
      </Button>
    </div>
  </form>
</template>

<script>
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Message from "primevue/message";
import { useVuelidate } from "@vuelidate/core";
import { email, required } from "@/i18n/i18nValidators";

export default {
  name: 'ResetPasswordForm',
  components: { InputText, Button, Message },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  data() {
    return {
      email: '',
      isSaving: false,
      success: false,
      errors: '',
    }
  },
  validations() {
    return {
      email: { required, email },
    }
  },
  computed: {
    resetButtonDisabled() {
      return this.v$.$invalid;
    }
  },
  methods: {
    async reset() {
      this.errors = null;
      const isFormValid = await this.v$.$validate();
      if (!isFormValid) return;

      this.isSaving = true;
      await this.$userService.resetPassword(this.email)
        .then(() => {
          this.errors = null;
          this.isSaving = false;
        }).catch(e => {
          this.errors = null;
          this.isSaving = false;
        });
      this.success = true;
    }
  }
}
</script>

<style scoped lang="scss">

</style>
